import { useSelector } from 'react-redux'
import { useState } from 'react'
import { jt, t } from 'ttag'

import { Text } from '@h2/components/typography/text'
import {
  loadBudgetResults,
  loadSubsequentBudgetResults
} from '@main/actions/assessments/budget'
import SearchQueryHandlerComponent from '@main/components/search/SearchQueryHandlerComponent'

import { Page } from '../../common/components/page'

const BudgetResults = props => {
  const pageTitle = t`Occupations that Meet Your Budget`
  const [filterModel, setFilterModel] = useState({})
  const loadFunction = loadBudgetResults
  const loadMoreFunction = loadSubsequentBudgetResults(filterModel)
  const searchRequest = useSelector(
    state => state.assessments.budget.budgetResultsResponse
  )

  return (
    <Page>
      <Page.Title>{pageTitle}</Page.Title>
      <Page.Layout>
        <Page.Content>
          <Text>
            {jt`You can compare up to four occupations by selecting the boxes to the left of the desired occupations and then clicking on the Compare Selected button at the bottom of the page. You can also filter occupation lists by Job Zone (preparation required), salary, and more to help you refine your search.`}
          </Text>
          <SearchQueryHandlerComponent
            loadFunction={loadFunction}
            loadMoreFunction={loadMoreFunction}
            setFilterModel={setFilterModel}
            searchRequest={searchRequest}
            {...props}
          />
        </Page.Content>
      </Page.Layout>
    </Page>
  )
}

export { BudgetResults }
